/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { DocumentType } from "~/features/myAccount/constants";
import {
  ComplianceDocument,
  ComplianceDocumentApiSubType,
  ComplianceDocumentApiSubTypeWithStatus,
  ComplianceDocumentWithStatus,
} from "~/features/myAccount/types";

export const transformToComplianceDocumentsWithStatus = (
  documents: ComplianceDocumentApiSubTypeWithStatus[],
): ComplianceDocumentWithStatus[] =>
  documents.map((document) => ({
    id: document.id,
    documentType: document.documenttype as unknown as DocumentType,
    filename: document.filename,
    resellerNote: document.resellernote,
    expiresAt: document.expires,
    createdAt: document.created,
    status: document.status,
  }));

const transformToComplianceDocumentsById = (
  documents: ComplianceDocumentApiSubType[],
): Record<number, ComplianceDocument> => {
  const byId: Record<number, ComplianceDocument> = {};

  documents.forEach((document) => {
    byId[document.id] = {
      id: document.id,
      documentType: document.documenttype as unknown as DocumentType,
      filename: document.filename,
      resellerNote: document.resellernote,
      expiresAt: document.expires,
      createdAt: document.created,
    };
  });

  return byId;
};

export default transformToComplianceDocumentsById;
